import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import Leto from './pages/leto/Leto';
import Rigo from './pages/rigo/Rigo';
import Topo from './pages/topo/Topo';
import Plao from './pages/plao/Plao';

import LetoPro from './pro/letopro/LetoPro';
import RigoPro from './pro/rigopro/RigoPro';
import TopoPro from './pro/topopro/TopoPro';
import PlaoPro from './pro/plaopro/PlaoPro';

import SEOComponent from './components/SEOComponent';
import { loadKeywords } from './utils/loadKeywords';

import TermsAndConditionsModal from "./components/TermsAndConditionsModal";

import "./App.css";

import { getAuth, signInWithPopup, signInWithRedirect, GoogleAuthProvider, signOut, onAuthStateChanged } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDyGVPHnTVyWimYSzCpGmMF_RMm1gxhpW4",
  authDomain: "pitics.com",
  projectId: "piticsjgat",
  storageBucket: "piticsjgat.firebasestorage.app",
  messagingSenderId: "898712575285",
  appId: "1:898712575285:web:cc5d6b753ae1597b38807c"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });

const LeftSidebar = () => <aside style={{ color: "#ffcc80" }} className="sidebar left-sidebar"><h1>Instant Notebook Label Stickers pitics.com</h1>
<h1>Instant Notebook Label Stickers pitics</h1><h1>Pitics Instant Notebook Label Stickers </h1>
<h1>Instant Notebook Label Stickers </h1>
Notebook Label Stickers, Notebook Stickers, Pitics Notebook Stickers, Book Stickers, Instant Stickers, Instant Notebook Stickers, Instant Notebook Stickers, Customized Notebook Stickers, Customized book stickers, Personalized Notebook Stickers, Personalized Book Sticers, Instant Customized Notebook Label Stickers, Instant Notebook Label Stickers with Personalized Photos, Ghibli Notebook Stickers, Favourite Cartoon Notebook Stickers, Instant Personalized Notebook Stickers, Personalized and Customized Book Stickers, Personalized and customized notebook stickers, Label stickers for Notebook, Personalized Label stickers for Notebooks,  Pitics, Pitics.com, Pitics Just Get And Try Pitics, Pitics.in, Pitics Just Get And Try, Pitics Instant Note Book Label Stickers, Pitics customized label stickers, Pitics Instant Label stickers, Pitics Instant Customized Notebook Label Stickers with personalized Ghibli, Personalized Photo Labels, Personalized Labels with Favourite Cartoon Notebook stickers, Students Label Notebook Stickers , Student Label Notebook stickers, Personalized Student Label book stickers, Student book stickers, Student book labels, student notebook labels, student notebook label stickers, student book stickers, student note book stickers, student personalized notebook label stickers, student personalized book label stickers, student customized notebook label stickers, student personalized notebook label stickers, personalized student notebook label stickers, student notebook stickers with photo, student book stickers with photo,
</aside>;
const RightSidebar = () => <aside style={{ color: "#ffcc80" }} className="sidebar right-sidebar"><h1>Instant Notebook Label Stickers pitics.com</h1>
<h1>Instant Notebook Label Stickers pitics</h1><h1>Pitics Instant Notebook Label Stickers </h1>
<h1>Instant Notebook Label Stickers </h1>Notebook Label Stickers, Notebook Stickers, Pitics Notebook Stickers, Book Stickers, Instant Stickers, Instant Notebook Stickers, Instant Notebook Stickers, Customized Notebook Stickers, Customized book stickers, Personalized Notebook Stickers, Personalized Book Sticers, Instant Customized Notebook Label Stickers, Instant Notebook Label Stickers with Personalized Photos, Ghibli Notebook Stickers, Favourite Cartoon Notebook Stickers, Instant Personalized Notebook Stickers, Personalized and Customized Book Stickers, Personalized and customized notebook stickers, Label stickers for Notebook, Personalized Label stickers for Notebooks,  Pitics, Pitics.com, Pitics Just Get And Try Pitics, Pitics.in, Pitics Just Get And Try, Pitics Instant Note Book Label Stickers, Pitics customized label stickers, Pitics Instant Label stickers, Pitics Instant Customized Notebook Label Stickers with personalized Ghibli, Personalized Photo Labels, Personalized Labels with Favourite Cartoon Notebook stickers, Students Label Notebook Stickers , Student Label Notebook stickers, Personalized Student Label book stickers, Student book stickers, Student book labels, student notebook labels, student notebook label stickers, student book stickers, student note book stickers, student personalized notebook label stickers, student personalized book label stickers, student customized notebook label stickers, student personalized notebook label stickers, personalized student notebook label stickers, student notebook stickers with photo, student book stickers with photo,
</aside>;

// Modified to check for expiry
const checkProStatus = async (uid) => {
  const docRef = doc(db, "proUsers", uid);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const data = docSnap.data();
    const subscribedAt = new Date(data.subscribedAt);
    const now = new Date();
    const threeYearsInMs = 3 * 365 * 24 * 60 * 60 * 1000;

    if (now - subscribedAt >= threeYearsInMs) {
      await setDoc(docRef, { ...data, isPro: false }, { merge: true });
      return false;
    }

    return data.isPro;
  }

  return false;
};

// Modified to store subscription timestamp
const setProStatus = async (uid) => {
  const docRef = doc(db, "proUsers", uid);
  await setDoc(docRef, {
    isPro: true,
    subscribedAt: new Date().toISOString()
  });
};

const App = () => {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [isPro, setIsPro] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isAccountMenuOpen, setAccountMenuOpen] = useState(false);
  const [isSigningOut, setIsSigningOut] = useState(false);
  const [showSignOutConfirm, setShowSignOutConfirm] = useState(false);
  const [showProDialog, setShowProDialog] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [price, setPrice] = useState(299);
  const [promoCode, setPromoCode] = useState("");
  const [isPromoCodeApplied, setIsPromoCodeApplied] = useState(false);
  const [keywords, setKeywords] = useState("");//for SEO keywords

  const dropdownRef = useRef(null);
  
  //for reload
   useEffect(() => {
    const hasReloaded = sessionStorage.getItem("hasReloaded");
    if (!hasReloaded) {
      sessionStorage.setItem("hasReloaded", "true");
      window.location.reload();
    }
  }, []);
  
  //for reload

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth > 1024) setMobileNavOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        const proStatus = await checkProStatus(currentUser.uid);
        setIsPro(proStatus);
      } else {
        setIsPro(false);
      }
    });
    return () => unsubscribe();
  }, []);


//for terms and conditions

  const [openModal, setOpenModal] = useState(false);


 // Fetch keywords from the external text file
 useEffect(() => {
  fetch("/seo-keywords.txt")
    .then((response) => response.text())
    .then((data) => {
      setKeywords(data.split(",").map(k => k.trim()));
    })
    .catch(console.error);
}, []);




  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setAccountMenuOpen(false);
      }
    };
    if (isAccountMenuOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isAccountMenuOpen]);

  const handleSignIn = async () => {
    try {
      if (/Mobi|Android/i.test(navigator.userAgent)) {
        await signInWithRedirect(auth, provider);
      } else {
        await signInWithPopup(auth, provider);
      }
    } catch (error) {
      console.error("Sign-in error", error);
      setError("Sign-in failed. Please try again.");
    }
  };

  const handleSignOut = async () => {
    setIsSigningOut(true);
    try {
      await signOut(auth);
      setUser(null);
      setIsPro(false);
      setAccountMenuOpen(false);
    } catch (error) {
      console.error("Sign-out error", error);
      setError("Sign-out failed. Please try again.");
    } finally {
      setIsSigningOut(false);
      setShowSignOutConfirm(false);
    }
  };

  const handleProClick = () => {
    if (!user) {
      setError("Please sign in first");
    } else {
      setShowProDialog(true);
    }
  };

  const closeProDialog = () => {
    setShowProDialog(false);
    setPromoCode("");
    setPrice(299);
    setIsPromoCodeApplied(false);
    setError(null);
  };

  const handlePromoCodeChange = (e) => {
  setPromoCode(e.target.value);
  setError(null);
};

const handleApplyPromoCode = () => {
  const code = promoCode.trim().toUpperCase();
  if (code === "NAMO300") {
    setPrice(99);
    setIsPromoCodeApplied(true);
  } else if (["LETO"].includes(code)) {
    setPrice(129);
    setIsPromoCodeApplied(true);
  } else {
    setPrice(299);
    setError("Invalid Promo Code");
    setIsPromoCodeApplied(false);
  }
};

const handleClearPromoCode = () => {
  setPromoCode("");
  setPrice(299);
  setError(null);
  setIsPromoCodeApplied(false);
};

const handleProPaymentSuccess = async () => {
  if (!user) return;

  setError(null);
  setSuccessMessage(null);

  // Detect legacy Android versions (Android 6 and below)
  const isLegacyAndroid = () => {
    const ua = navigator.userAgent || "";
    return /Android [0-6]\./.test(ua);
  };

  // Detect in-app browsers (Instagram, Facebook, etc.)
  const isInAppBrowser = () => {
    const ua = navigator.userAgent.toLowerCase();
    return (
      /fbav|instagram|line|wv|snapchat|linkedin|okhttp/.test(ua) ||
      (ua.includes("mobile") && ua.includes("version/") && !ua.includes("chrome"))
    );
  };

  // Show alert and exit if not supported
  if (isLegacyAndroid()) {
    alert(
      "⚠️ Your device or browser may not support the payment gateway. Please update your browser or try on a newer device."
    );
    return;
  }

  if (isInAppBrowser()) {
    alert(
      "⚠️ Payments may not work in this browser (e.g., Instagram/Facebook). Please open in Chrome or your system browser for a smooth payment experience."
    );
    return;
  }

  try {
    if (!window.Razorpay) {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      script.onload = initiatePayment;
      script.onerror = () => {
        console.error("Failed to load Razorpay script");
        setError("Unable to load payment SDK. Please try again later.");
      };
      document.body.appendChild(script);
    } else {
      initiatePayment();
    }
  } catch (err) {
    console.error("Unexpected error during Razorpay setup:", err);
    setError("Unexpected error occurred. Please try again.");
  }

 async function initiatePayment() {
  try {
    const response = await fetch("https://pitics4.onrender.com/create-order", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        amount: price * 100,
        promoCode: promoCode.trim().toUpperCase(),
      }),
    });

    const data = await response.json();

    if (!data.success) {
      setError(data.error || "Failed to create payment order.");
      return;
    }

    const options = {
      key: "rzp_live_eYF8RXUJ9ySFMa",
      amount: data.amount,
      currency: data.currency,
      name: "Pitics Technologies",
      description: "3-Year Pro Subscription",
      image: "https://pitics.com/logo.png",
      order_id: data.orderId,
      handler: async function (response) {
        try {
          const verifyRes = await fetch("https://pitics4.onrender.com/verify-payment", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            }),
          });

          const verifyData = await verifyRes.json();

          if (verifyData.success) {
            try {
              await setProStatus(user.uid);
              setIsPro(true);
              closeProDialog();
              setSuccessMessage("✅ Payment successful! Pro activated.");
              setTimeout(() => setSuccessMessage(null), 3000);
            } catch (firestoreErr) {
              console.error("Error updating Firestore with Pro status:", firestoreErr);
              setError("Payment succeeded but activation failed. Please contact support.");
            }
          } else {
            console.error("Verification failed:", verifyData.message || "No message");
            setError("Payment failed. Please try again using card payment.");
          }
        } catch (verifyErr) {
          console.error("Verification exception:", verifyErr);
          setError("Payment verification failed. Please try again using card payment.");
        }
      },
      prefill: {
        name: user.displayName,
        email: user.email,
        contact: user.phoneNumber || "",
      },
      theme: { color: "#3399cc" },
	    method: {
    netbanking: true,
    card: true,
    upi: true,
    wallet: true,
  },
  redirect: true, // ✅ this opens payment in a new tab
	  
	  
      config: {
        display: {
          blocks: {
            all_methods: {
              name: "4G📱 Users prefer Card Payments (⚠️UPI failures️)",
              instruments: [
                { method: "card" },
                { method: "upi" },
                { method: "wallet" },
                { method: "paylater" },
                { method: "netbanking" },
              ],
            },
          },
          sequence: ["block.all_methods"],
          preferences: {
            show_default_blocks: false,
          },
        },
      },
      modal: {
        ondismiss: function () {
          // Optionally alert the user
          // alert("Payment popup closed. You can try again.");
        },
      },
    };

    setTimeout(() => {
      const rzp = new window.Razorpay(options);
      rzp.open();
    }, 100); // delay to prevent popup block

  } catch (err) {
    console.error("Order creation or Razorpay error:", err);
    setError("Failed to process payment. Please try again.");
  }
}

};


  return (
    <Router>
  <div className="app">
    <header className="header">
      <div className="header-content">
        {windowWidth <= 1024 && (
          <button className="mobile-nav-toggle" onClick={() => setMobileNavOpen(!isMobileNavOpen)}>☰</button>
        )}
        <img src="/banner.png" alt="Banner" className={windowWidth > 1024 ? "banner-image" : "banner-image1"} />
        {windowWidth > 1024 && (
          <nav className="desktop-nav desktop-nav-inline">
            <ul className="nav-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/rigo">Midam</Link></li>
              <li><Link to="/topo">Nibha</Link></li>
              <li><Link to="/plao">Rusa</Link></li>
              <li><Link to="/leto">Obla</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav>
        )}
        <div className="pro-section">
          {isPro ? (
            <span className="pro-badge">🌟 Pro Active</span>
          ) : (
            <button onClick={handleProClick} className="pro-button">Click for Pro</button>
          )}
        </div>
        <div className="auth-section">
          {user ? (
            <div className="account-menu">
              <button onClick={() => setAccountMenuOpen(!isAccountMenuOpen)} className="account-button">
                <img src={user.photoURL || "/jashvin.png"} alt="" className="profile-image" />
              </button>
              <div className={`account-dropdown ${isAccountMenuOpen ? "active" : ""}`} ref={dropdownRef}>
                <button className="close-btn" onClick={() => setAccountMenuOpen(false)}>✖</button>
                <p>Welcome, {user.displayName || "User"}</p>
                <button onClick={() => setShowSignOutConfirm(true)}>Sign Out</button>
              </div>
            </div>
          ) : (
            <button onClick={handleSignIn} className="gsi-material-button">
              <div className="gsi-material-button-content-wrapper">
                <div className="gsi-material-button-icon">
                  <img src="/glogo.png" alt="Google Logo" style={{ width: '24px', height: '24px' }} />
                </div>
                <span style={{ display: 'none' }}>Sign in with Google</span>
              </div>
            </button>
          )}
        </div>
      </div>
    </header>

    {windowWidth <= 1024 && isMobileNavOpen && (
      <nav className="mobile-nav">
        <button className="close-nav" onClick={() => setMobileNavOpen(false)}>✖</button>
        <ul className="nav-links">
          <li><Link to="/" onClick={() => setMobileNavOpen(false)}>Home</Link></li>
          <li><Link to={isPro ? "/rigopro" : "/rigo"} onClick={() => setMobileNavOpen(false)}>Midam</Link></li>
          <li><Link to={isPro ? "/topopro" : "/topo"} onClick={() => setMobileNavOpen(false)}>Nibha</Link></li>
          <li><Link to={isPro ? "/plaopro" : "/plao"} onClick={() => setMobileNavOpen(false)}>Rusa</Link></li>
          <li><Link to={isPro ? "/letopro" : "/leto"} onClick={() => setMobileNavOpen(false)}>Obla</Link></li>
          <li><Link to="/contact" onClick={() => setMobileNavOpen(false)}>Contact</Link></li>
        </ul>
      </nav>
    )}
 
    <main className="main-content"> 
      {windowWidth > 1024 && <LeftSidebar />}
      <div className="center-content">
        <Routes>
          {/* Home */}
          <Route path="/" element={isPro ? <LetoPro /> : <Leto />} />

          {/* Midam */}
          <Route path="/rigo" element={<Rigo />} />
          <Route path="/rigopro" element={<RigoPro />} />

          {/* Nibha */}
          <Route path="/topo" element={<Topo />} />
          <Route path="/topopro" element={<TopoPro />} />

          {/* Rusa */}
          <Route path="/plao" element={<Plao />} />
          <Route path="/plaopro" element={<PlaoPro />} />

          {/* Obla */}
          <Route path="/leto" element={<Leto />} />
          <Route path="/letopro" element={<LetoPro />} />

          {/* Contact */}
          <Route path="/contact" element={<TermsAndConditionsModal />} />
        </Routes>
      </div>
      {windowWidth > 1024 && <RightSidebar />}
    </main>

    {!isPro && (
      <p
        style={{
          fontSize: '12px',
          position: 'relative',
          top: window.innerWidth > 1023 ? '-120px' : '-103px',
        }}
      >
        I agree all TnCs and Privacy Policy.{` `}
        <Link to="/contact" style={{ color: 'red', textDecoration: 'underline' }}>
          click here
        </Link>
      </p>
    )}

    <>
	<div className="blinking-banner">
      PITICS - Personal Informative Text Included For Communication On Stickers
    </div>
      <footer className="footer">
        <p>Pitics Technologies<sup>&copy;</sup> 2025. All rights reserved.</p>
      </footer>

      {openModal && (
        <TermsAndConditionsModal onClose={() => setOpenModal(false)} />
      )}
    </>

    {showProDialog && (
      <div className="pro-dialog show">
        <div className="dialog-content">
          <button className="close-btn" onClick={closeProDialog}>✖</button>
          <p>3-Year Pro Subscription: Rs. {price}/-</p>
          <div className="promo-code-section">
            <div className="promo-code-wrapper">
              <input
                type="text"
                placeholder="Enter Promo Code"
                value={promoCode}
                onChange={handlePromoCodeChange}
              />
              {isPromoCodeApplied && (
                <button className="clear-promo-btn" onClick={handleClearPromoCode}>✖</button>
              )}
            </div>
            <button className="apply-promo-btn" onClick={handleApplyPromoCode}>Apply</button>
          </div>
          <p>
            I agree all TnCs and Privacy Policy.{` `}
            <Link to="/contact" style={{ color: 'red', textDecoration: 'underline' }}>
              click here
            </Link>
          </p>
          <button onClick={handleProPaymentSuccess}>Pay Rs. {price}/-</button>
        </div>
      </div>
    )}

    {showSignOutConfirm && (
      <div className="signout-modal">
        <div className="modal-content">
          <p>Are you sure you want to sign out?</p>
          <button onClick={handleSignOut} disabled={isSigningOut}>
            {isSigningOut ? "Signing out..." : "Yes, Sign Out"}
          </button>
          <button onClick={() => setShowSignOutConfirm(false)}>Cancel</button>
        </div>
      </div>
    )}

    {error && (
      <div className="error-message-modal">
        <div className="modal-content">
          <button className="close-btn" onClick={() => setError(null)}>✖</button>
          <p>{error}</p>
        </div>
      </div>
    )}

    {successMessage && (
      <div
        className="success-message-modal"
        style={{
          position: "fixed",
          top: "80px",
          right: "20px",
          backgroundColor: "#d4edda",
          color: "#155724",
          padding: "10px 20px",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          zIndex: 1000
        }}
      >
        {successMessage}
      </div>
    )}
  </div>

  <SEOComponent
    title="Pitics Just Get And Try"
    description="Instant Customized Notebook Label Stickers with YOur Photo or Ghibli or Favourite Cartoon"
    keywords={keywords}
  />
</Router>

  );
};

export default App;
